import '.im{display:inline-block;}.ssr-plugin'
import '.in{margin-top:1.5rem;}.ssr-plugin'
import '.c2{font-size:0.875rem;}.ssr-plugin'
import '.io{color:var(--palette-blue-500);}.ssr-plugin'
import '.h6{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="im in c2 io h6"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
